<div
    class="copy-to-clipboard"
    [pTooltip]="tooltip() | translate"
    [tooltipPosition]="'top'"
    [class.copied]="copiedState"
    (click)="copyToClipboard()"
    [title]="tooltip() | translate">
    @if (copiedState) {
        <i class="fa fa-regular fa-check"></i>
    } @else {
        <i [class]="icon()"></i>
    }
</div>
